export interface UserManagementState {
  userList: Array<any>;
  userByFieldList: Array<any>;
  userById: any;
  addUserResponse: any;
  updateUserResponse: any;
  deleteUserResponse: any;
  userListByPartnerId: Array<any>;
  partnersList: Array<any>;
  adminsList: Array<any>;
}

export const initialState: UserManagementState = {
  userList: null,
  userByFieldList: null,
  userById: null,
  addUserResponse: null,
  updateUserResponse: null,
  deleteUserResponse: null,
  userListByPartnerId: null,
  partnersList: null,
  adminsList: null,
};
